import React from 'react';
import CommerceDocsPage from './CommerceDocsPage';

export default function ReceiptsPage() {
  return <CommerceDocsPage mode="receipt" />;
}
